import { getUserPremiumField } from "data"
import Link from "next/link"
import { iModal } from "typings"
import { useAuth } from "../../../context/authContext"
import { useModal, useTeams } from "../../../global/hooks"
import Button from "../../1_atom/buttons/button"
import { LoadingSpinner } from "../../1_atom/empty/notFound"
import { ManageBoostsModal } from "./manageBoostsModal"

export const BoostDistribution = () => {

  const { teams, loadTeamsState } = useTeams()
  const auth = useAuth()
  const [ triggerModal ] = useModal()
  const distribution = auth?.userData?.[getUserPremiumField()]?.boostDistribution || {}
  const usedBoosts = Object.values(distribution).reduce((acc, item) => {
    acc += item.boostsSent
    return acc
  }, 0)

  const Distribution = () => {

    if(loadTeamsState !== "loaded") return (
      <div className="flex-row p2 bg3 rounded center-center">
        <LoadingSpinner />
      </div>
    )
    
    const NoneDistributed = () => {
      return (
        <div className="flex-row p2 bg3 rounded center-center">
          <span className="weak-text">No boosts distributed</span>
        </div>
      )
    }

    if(Object.entries(distribution)?.length < 1) return <NoneDistributed />
    return (
      <>
        {Object.entries(distribution).map(([teamID, distr]) => {
          const team = teams?.find((t) => t.id === teamID)
          return (
            <div key={teamID} className="left-right-container p2 bg3 rounded align-center">
              <Link href={{ pathname: "/team", query: { teamID: team?.id } }}>
                <span>{team?.teamName}</span>
              </Link>
              <span className="font-bold text-base">{distr.boostsSent} boosts</span>
            </div>
          )
        })}
      </>
    )
  }

  return (
    <div className="flex-col gap1 w100">
      <div className="flex-row gap1 align-center">
        <h5>Boost distribution</h5>
        <span>
          {usedBoosts}/{auth?.userData?.[getUserPremiumField()]?.availableBoosts} used
        </span>
      </div>
      <Distribution />
      <Button
        text="Distribute boosts"
        addClass="align-self-end"
        click={() => {
          const modal: iModal = {
            options: { size: "small" },
            top: "Boost distribution",
            middle: (
              <ManageBoostsModal />
            )
          }
          triggerModal(modal)
        }}
      />
    </div>
  )
}